import { partnerClient } from '@modules/core/services';
import { CampaignTrackingOverviewData, FetchCampaignTrackingOverviewParams } from './campaign-tracking.types';

export const fetchCampaignTrackingOverviewData = async ({
  groupKey,
}: FetchCampaignTrackingOverviewParams): Promise<CampaignTrackingOverviewData> => {
  return await partnerClient.get(`campaign_tracking/overview`, {
    params: {
      groupKey,
    },
  });
};
